module.exports = __webpack_public_path__ + "static/media/Koobot_Processed_01B.6fc2f140.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/Koobot_Processed_01B.mp3
// module id = 103
// module chunks = 0